import React from 'react';
import { ObservedItem } from './ObservedItem';
import './Styles/BlockGrid.css';

export class BlockGrid extends React.Component {
  render() {
    const maxW = this.props.maxWidth || '900px';
    return (
      <div className="Grid__Container" style={{ maxWidth: maxW }}>
        {this.props.items.map(this.renderBlock)}
      </div>
    );
  }

  renderBlock = (block, index) => {
    return (
      <ObservedItem
        key={index}
        contClass={'Grid__Block'}
        handleIntersection={this.handleIntersection}
        intersectionOptions={{
          threshold: 0.35
        }}
      >
        {this.props.renderItem(block)}
      </ObservedItem>
    );
  };

  handleIntersection = entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('slideIn');
    });
  };
}
